import _extends from '@babel/runtime/helpers/extends';
import React__default, { useCallback } from 'react';
import styled from 'styled-components';
import { u as useInlinePopover } from '../Popover/useInlinePopover-D_iJ07xC.js';
import { P as PopoverTrigger } from '../Popover/Popover.styles-BcziRqke.js';
import { P as PopoverContainer } from '../Popover/PopoverContainer-Bu6MTiRK.js';
import { A as AnchoredAlertContentContainer } from './AnchoredAlertContent-CNMaWcdk.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const LowerElevationPopoverContainer = /*#__PURE__*/styled(PopoverContainer).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1djd4qz-0"
})(["z-index:", ";"], ({
  theme
}) => theme.anchoredAlert.zIndex);
const AnchoredAlert = ({
  align = 'center',
  children,
  closeButtonLabel = 'Dismiss Alert',
  header,
  headerLevel,
  footer,
  isOpen = false,
  message = undefined,
  onClick,
  onCloseButtonClick = noop,
  position = 'top',
  spacing = 0,
  trigger,
  fullWidthTrigger,
  variant = 'default',
  withCloseButton = true,
  portalRef,
  boundaryRef,
  focusableBody = false,
  ...rest
}) => {
  const placement = align === 'center' ? position : `${position}-${align}`;
  const {
    attributes,
    styles,
    arrowElementRef,
    setPopoverElement,
    setTriggerElement,
    update
  } = useInlinePopover({
    offsetDistance: spacing,
    placement: placement,
    enableFlip: !!boundaryRef,
    preventOverflow: {
      mainAxis: !!boundaryRef
    },
    boundaryRef,
    withArrow: true
  });

  /**
   * Handles mouse clicks on the <AnchoredAlert /> close button.
   */
  const handleCloseClicked = useCallback(event => {
    event.stopPropagation();

    // call the callback function passed via props.
    onCloseButtonClick === null || onCloseButtonClick === void 0 || onCloseButtonClick(event);
  }, [onCloseButtonClick]);

  /**
   * Catches the click event from the <AnchoredAlert /> trigger and only
   * call the 'onClick' callback if it was passed.
   */
  const preventTriggerClickThrough = useCallback(event => {
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
  }, [onClick]);
  const handleAnchoredAlertEntering = useCallback(isAppearing => {
    if (!isAppearing && update !== null) {
      update();
    }
  }, [update]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PopoverTrigger, {
    onClick: preventTriggerClickThrough,
    ref: setTriggerElement,
    $fullWidth: fullWidthTrigger
  }, trigger), /*#__PURE__*/React__default.createElement(LowerElevationPopoverContainer, _extends({
    attributes: attributes,
    disablePortal: !portalRef,
    handlePopoverEntering: handleAnchoredAlertEntering,
    isOpen: isOpen,
    setPopoverElement: setPopoverElement,
    styles: styles,
    variant: variant,
    portalRef: portalRef,
    withArrow: true,
    arrowElementRef: arrowElementRef
  }, rest), /*#__PURE__*/React__default.createElement(AnchoredAlertContentContainer, {
    closeButtonLabel: closeButtonLabel,
    header: header,
    headerLevel: headerLevel,
    footer: footer,
    handleCloseClicked: handleCloseClicked,
    message: message,
    variant: variant,
    withCloseButton: withCloseButton
  }, children)));
};

export { AnchoredAlert as A };
//# sourceMappingURL=AnchoredAlert-gGWvqlOj.js.map
